import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.isTag}}\n  {{discourse-tag this.rowValue noHref=true description=this.item.description count=this.item.count}}\n{{else}}\n  <span class=\"name\">{{this.item.name}}</span>\n{{/if}}", {
  moduleName: "select-kit/components/tag-row.hbs"
});